module.exports = __webpack_public_path__ + "img/kes.56da9ed6.png";